<template>
  <div class="ProductReview-card">
    <li>
      <div
        class="ProductReview-username"
        v-text="`${review.firstname} ${review.lastname.charAt(0)}.`"
      />
      <div class="ProductReview-inner">
        <div class="ProductReview-innerHead">
          <StarRating
            :rating="Number(review.rate)"
            v-bind:increment="0.1"
            v-bind:read-only="true"
            v-bind:max-rating="5"
            v-bind:star-size="18"
          ></StarRating>
          <div class="ProductReview-publishDate">
            <span v-if="review.publish_date">
              Avis publié le {{ new Date(review.publish_date) | formatDate }}
            </span>
          </div>
        </div>

        <div class="ProductReview-body">
          <p v-text="review.review" />
        </div>
      </div>
    </li>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: "ProductReviewCard",
  components: {
    StarRating,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
};
</script>
